"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _formik = require("formik");
var _transformHelpers = require("../../utils/transformHelpers");
var _MaskedInput = _interopRequireDefault(require("../../Input/MaskedInput"));
require("./SearchableSelect.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SearchableSelect = function SearchableSelect(props) {
  var initialValue = props.initialValue,
    disabled = props.disabled,
    name = props.name,
    onChange = props.onChange,
    onSearching = props.onSearching,
    placeholder = props.placeholder,
    mask = props.mask,
    icon = props.icon,
    noResultsLabel = props.noResultsLabel,
    _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options,
    infoText = props.infoText;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    elementSelected = _useState4[0],
    setElementSelected = _useState4[1];
  var _useFormikContext = (0, _formik.useFormikContext)(),
    setFieldValue = _useFormikContext.setFieldValue,
    setFieldTouched = _useFormikContext.setFieldTouched;
  var searchField = (0, _transformHelpers.getFieldSearch)(name);
  var lastSearchField = (0, _transformHelpers.getLastSearchField)(name);
  var handleSelection = (0, _react.useCallback)(function (_ref) {
    var value = _ref.value,
      label = _ref.label;
    setFieldValue(name, value);
    setFieldValue(searchField, label);
    setFieldValue(lastSearchField, label);
    setTimeout(function () {
      setFieldTouched(searchField, true);
      setFieldTouched(name, true);
    }, 1);
    setElementSelected(value);
    setOpen(false);
    if (onChange) {
      onChange(value);
    }
  }, [onChange, name, setFieldValue, searchField, lastSearchField]);
  var toogleOpen = (0, _react.useCallback)(function () {
    setOpen(!open);
  }, [open]);
  var handleOpen = (0, _react.useCallback)(function () {
    setOpen(true);
  }, []);
  (0, _react.useEffect)(function () {
    if (initialValue) {
      setFieldValue(searchField, initialValue);
    }
  }, [initialValue, name, setFieldValue]);
  var handleBlur = (0, _react.useCallback)(function (e) {
    setTimeout(function () {
      var target = document.activeElement;
      var focusedElement = target ? target.id || target || target.tagName : '';
      var isFocusedCalendar = focusedElement.className.indexOf('SercheableSelect__options--open') !== -1;
      setOpen(isFocusedCalendar);
      if (props.onBlur) {
        props.onBlur(e);
      }
    }, 1);
  }, [props]);
  var handleOnChange = (0, _react.useCallback)(function (e) {
    if (onSearching) {
      var value = e.target.value;
      onSearching(value);
    }
  }, [onSearching]);

  // Starts classNames block
  var containerCN = (0, _classnames["default"])('SercheableSelect__input', {
    'SercheableSelect__input--open': open
  });
  var calendarCN = (0, _classnames["default"])("SercheableSelect__options", {
    'SercheableSelect__options--open': open
  });
  var iconOpen = open ? 'svg-icon-chevron-up' : 'svg-icon-chevron-down';
  var iconCn = (0, _classnames["default"])("svg-icon", icon || iconOpen);
  var withoutResultsLabel = noResultsLabel || 'No hay resultados';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "SercheableSelect"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: containerCN
  }, /*#__PURE__*/_react["default"].createElement(_MaskedInput["default"], {
    label: props.label,
    type: "text",
    mask: mask,
    placeholder: props.placeholder,
    name: "".concat(props.name, "_search"),
    id: props.id,
    maskPlaceholder: "",
    disabled: disabled,
    onBlur: handleBlur,
    onChange: handleOnChange,
    infoText: infoText,
    right: /*#__PURE__*/_react["default"].createElement("div", {
      onClick: function onClick() {
        return disabled ? {} : toogleOpen();
      },
      onKeyPress: function onKeyPress() {
        return disabled ? {} : toogleOpen();
      },
      role: "button",
      tabIndex: "0",
      className: iconCn
    }),
    onFocus: handleOpen
  })), /*#__PURE__*/_react["default"].createElement("div", {
    tabIndex: 0,
    onBlur: function onBlur(e) {
      setOpen(false);
      if (props.onBlur) {
        props.onBlur(_objectSpread({}, e));
      }
    },
    className: calendarCN
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "col-form-label"
  }, placeholder), options && (0, _transformHelpers.transformIdOfList)(options).map(function (_ref2) {
    var value = _ref2.value,
      label = _ref2.label,
      disabled = _ref2.disabled,
      id = _ref2.id;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: id,
      onClick: function onClick() {
        return disabled ? {} : handleSelection({
          value: value,
          label: label
        });
      },
      className: (0, _classnames["default"])("SercheableSelect__options__element ".concat(disabled ? '__element-disabled' : ''), {
        'SercheableSelect__options__element--selected': value === elementSelected
      })
    }, label);
  }), (!options || options && options.length === 0) && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('SercheableSelect__options__element', '__element-disabled')
  }, withoutResultsLabel)));
};
SearchableSelect.propTypes = {
  label: _propTypes["default"].string,
  name: _propTypes["default"].string,
  placeholder: _propTypes["default"].string
};
SearchableSelect.defaultProps = {
  label: '',
  name: '',
  placeholder: ''
};
var _default = exports["default"] = SearchableSelect;